import React from 'react';
import { IBackdropProps } from './Backdrop.types';

export const Backdrop = ({ disableBackdrop }: IBackdropProps) => (
  <div className="backdrop" onClick={disableBackdrop}></div>
);
